import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
const COLS = ["demandes", "rdvs", "missions", "echanges"];
const DataContext = createContext(null);

export const DataProvider = ({ children }) => {
  const [data, setData] = useState({ demandes: [], rdvs: [], missions: [], echanges: [] });
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    const res = await Promise.all(COLS.map((c) => api.get(`/${c}`).then((r) => r.data)));
    setData(Object.fromEntries(COLS.map((c, i) => [c, res[i]])));
    setLoading(false);
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const save = useCallback(async (col, item, id) => {
    const res = id ? await api.put(`/${col}/${id}`, item) : await api.post(`/${col}`, item);
    await reload();
    return res.data;
  }, [reload]);

  const patch = useCallback(async (col, id, fields) => {
    await api.patch(`/${col}/${id}`, fields);
    await reload();
  }, [reload]);

  const remove = useCallback(async (col, id) => {
    await api.delete(`/${col}/${id}`);
    await reload();
  }, [reload]);

  const byId = useMemo(() => Object.fromEntries(data.demandes.map((d) => [d.id, d])), [data.demandes]);

  return (
    <DataContext.Provider value={{ ...data, loading, reload, save, patch, remove, byId }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
